export class GamepadStatus {
  private scene: any
  private badge: any
  private text: any
  private container: any
  private connected: boolean = false

  constructor(scene: any) {
    this.scene = scene
    this.badge = scene.add.rectangle(0, 0, 140, 28, 0x111111, 0.8)
    this.badge.setOrigin(1, 0)

    this.text = scene.add.text(-8, 6, 'Gamepad: Disconnected', { color: '#fff', fontSize: '12px' })
    this.text.setOrigin(1, 0)

    const container = scene.add.container(0, 0, [this.badge, this.text])
    container.setName('GamepadStatus')
    this.container = container
  }

  setConnected(connected: boolean) {
    this.connected = connected
    const color = connected ? 0x1e8e3a : 0x333333
    // @ts-ignore
    this.badge.fillColor = color
    this.text.setText(connected ? 'Gamepad: Connected' : 'Gamepad: Disconnected')
  }
}

export default GamepadStatus
